import { useTranslation } from 'react-i18next';

import {
  ConfirmationDialogActionProceedButton,
  ConfirmationDialogActions,
  ConfirmationDialogBodyMutedText,
  ConfirmationDialogContainer,
  ConfirmationDialogHeader,
  type ConfirmationDialogContainerProps,
} from './elements.confirmation-dialog';

export type WarningDialogProps = Omit<ConfirmationDialogContainerProps, 'subject'> &
  React.PropsWithChildren<{
    title: string;
  }>;

export const WarningDialog = (props: WarningDialogProps) => {
  const { title, children, onClose, ...restProps } = props;
  const { t } = useTranslation('dialogs');

  return (
    <ConfirmationDialogContainer subject="warning" onClose={onClose} {...restProps}>
      <ConfirmationDialogHeader>{title}</ConfirmationDialogHeader>

      <ConfirmationDialogBodyMutedText>{children}</ConfirmationDialogBodyMutedText>

      <ConfirmationDialogActions>
        <ConfirmationDialogActionProceedButton onClick={onClose}>
          {t('warning-dialog.actions.close')}
        </ConfirmationDialogActionProceedButton>
      </ConfirmationDialogActions>
    </ConfirmationDialogContainer>
  );
};
